import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import {toast} from "react-toastify";
import Modal from "../sections/MUI/Modal";
import Back from "../sections/Back";
import Field from "../sections/MUI/Field";
import File from "../sections/MUI/File";
import Button from "../sections/MUI/Button";

class EditExpert extends Component {

    state = {
        id: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        image: null,
        chatId: "",
        services: [],

        servicesList: [],

        modalServices: false
    };

    componentDidMount() {
        config.scrollTop();
        this.getServices("");
        this.getExpert();
    }

    getServices(search = "") {
        axios.get(`${config.api}/admin/service?token=${config.token}&search=${search}`)
            .then(r => {
                this.setState({servicesList: r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    getExpert() {
        axios.get(`${config.api}/admin/expert?token=${config.token}&id=${this.props.params.id}`)
            .then(r => {
                const {id, firstName, lastName, phoneNumber, chatId, services} = r.data.result
                this.setState({
                    id,
                    firstName,
                    lastName,
                    phoneNumber,
                    chatId: chatId.toString(),
                    services: services.map(s => {
                        return s.id
                    })
                });
            })
            .catch(err => {

            });
    }

    handleServiceClick(id) {
        let {services} = this.state;
        let is = false;
        services.map((s, i) => {
            if (s === id) {
                is = true;
                services.splice(i, 1);
            }
        });

        if (!is) {
            services.push(id);
        }

        this.setState({services});
    }

    serviceIsActive(id) {
        const {services} = this.state;
        return services.includes(id);
    }


    submit() {
        const {id, firstName, lastName, phoneNumber, image, chatId, services} = this.state;
        if (firstName !== "" && lastName !== "" && chatId !== "" && services.length > 0) {
            let params = new FormData();
            params.append("id", id);
            params.append("firstName", firstName);
            params.append("lastName", lastName);
            params.append("phoneNumber", phoneNumber);
            params.append("image", image);
            params.append("chatId", chatId);
            params.append("services", JSON.stringify(services));

            toast.info("درحال ثبت ...")
            axios.put(`${config.api}/admin/expert?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    toast.success("با موفقیت ثبت شد.");
                    this.getExpert();
                    this.getExpert();
                })
                .catch(err => {
                    config.handleError(err)
                });

        } else {
            toast.error("همه فیلدها را تکمیل کنید.")
        }
    }

    delete() {
        const {id} = this.state;
        toast.info("در حال حذف ...")
        axios.delete(`${config.api}/admin/expert?token=${config.token}&id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.")
                setTimeout(() => {
                    this.props.navigate(-1);
                }, 1500)
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    render() {
        const {
            modalServices, servicesList, services,
            firstName, lastName, phoneNumber, id, chatId, image
        } = this.state;
        return (
            <div className="edit-expert">
                {
                    modalServices ?
                        <Modal
                            onCloseClick={() => this.setState({modalServices: false})}
                            icon="list"
                            title="لیست خدمات"
                            display={modalServices}>
                            <div className="modal-services">
                                {
                                    servicesList.map((s, i) =>
                                        <article key={"service" + i}
                                                 onClick={() => this.handleServiceClick(s.id)}
                                                 className={this.serviceIsActive(s.id) ? "active" : ""}>
                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="image"><img src={s.image} alt=""/></div>
                                                </div>
                                                <div className="col">
                                                    <p className="title">{s.title}</p>
                                                </div>
                                            </div>
                                        </article>
                                    )
                                }
                            </div>
                        </Modal>
                        : null
                }

                <Back {...this.props}/>


                <div className="row">
                    <div className="col-md-6">
                        <Field name="firstName"
                               value={firstName}
                               label="نام"
                               maxLength={100}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <Field name="lastName"
                               value={lastName}
                               label="نام خانوادگی"
                               maxLength={100}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <File name="image"
                              value={image}
                              label="عکس پرسنلی"
                              accept="image/*"
                              multiple={false}
                              onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <Field
                            type="number"
                            name="chatId"
                            value={chatId}
                            style={{direction: "ltr"}}
                            label="آی دی عددی تلگرام"
                            maxLength={20}
                            onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-12">
                        <Field
                            name="phoneNumber"
                            value={phoneNumber}
                            style={{direction: "ltr"}}
                            label="شماره موبایل"
                            maxLength={13}
                            onChange={(name, value) => this.setState({[name]: value})}/>

                    </div>
                    <div className="col-md-12">
                        <Button submit={false}
                                icon="list"
                                onClick={() => this.setState({modalServices: true})}>لیست خدمات</Button>
                        <div className="row justify-content-between">
                            <div className="col-md-5">
                                <Button submit={false} onClick={() => this.submit()} icon="edit">ویرایش
                                    کردن</Button>
                            </div>
                            <div className="col-md-5">
                                <Button submit={false} icon="trash"
                                        backgroundColor="#E53935"
                                        onDoubleClick={() => this.delete()}>حذف کردن (دوبار کلیک)</Button>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default gpn(EditExpert);